import React, {Component} from 'react';
import RedirectOnlyHome from "../common/RedirectOnlyHome";

class SuccessPageSkipPayment extends Component {
	constructor(props) {
		super(props);

		this.state = {};
	}
	render() {
		return (<>
			<RedirectOnlyHome />
			<div id={'id_success_page'} className={'col text-center'}>
				<h3 style={{color:"#d63545"}}>Your reservation request has been received.</h3>
				<div>
					<br/><br/>
					Thank you for completing your reservation.  We will begin the process of allocating a vehicle and then submitting a request for payment later.
				</div>
				<div>
					<br/><br/>
					<strong>Have a nice day!</strong><br/>
					<em>Go With The Gecko Team</em>
				</div>
			</div>
		</>);
	}
}

export default SuccessPageSkipPayment;